import { Container, Divider } from '@mantine/core';
import React, { forwardRef, useMemo } from 'react';

import { EnvironmentCountries, UTBReportDataDeclarant, UTBReportDataGroup, UTBReportDataImporter, UTBReportDataRepresentative } from '@e-origin/shared';

import { computeResources } from '../resources';
import { UTB_REPORT_CONTAINER_CLASS, UTB_REPORT_CONTAINER_STYLE } from '../styles';
import { TranslationFn } from '../translations';
import { UTBObjectionClause } from './UTBObjectionClause';
import { UTBResources } from './UTBResources';
import { UTBSubHeader } from './UTBSubHeader';
import { UTBTotal } from './UTBTotal';
import { UTBTotalPerResource } from './UTBTotalPerResource';

export interface UTBReportBodyProps {
  representative: UTBReportDataRepresentative;
  utbDeclarant: UTBReportDataDeclarant;
  importer: UTBReportDataImporter;
  group: UTBReportDataGroup;
  t: TranslationFn;
  country: string;
}

export const UTBReportBody = forwardRef<HTMLDivElement, UTBReportBodyProps>(({ representative, utbDeclarant, group, importer, t, country }, ref) => {
  const resources = useMemo(() => computeResources(group), [group]);

  return (
    <Container p={0} fluid ref={ref} className={UTB_REPORT_CONTAINER_CLASS} style={UTB_REPORT_CONTAINER_STYLE}>
      <UTBSubHeader representative={representative} declarant={utbDeclarant} importer={importer} group={group} t={t} />

      {country !== EnvironmentCountries.BE && (
        <>
          <Divider />
          <UTBObjectionClause t={t} />
        </>
      )}

      {group.declarations.map((declaration, declarationIdx) => (
        <UTBResources key={declarationIdx} group={group} declaration={declaration} t={t} />
      ))}

      <UTBTotalPerResource resources={resources} t={t} />

      <UTBTotal resources={resources} t={t} />
    </Container>
  );
});
